<template>
    <!-- Основной блок карточки TG продукта (версия для менеджеров) -->
    <div class="tg-product-card-block">

        <!-- Левая сторона карточки -->
        <div class="left-side">

            <!-- Блок с фото товара -->
            <div class="tg-product-image-block">
                <!-- Фото товара -->
                <img :src="tg_product.photo_url" alt="Фото товара" class="tg-product-image">

                <!-- Название товара -->
                <div class="tg-product-name">{{ tg_product.product_name }}</div>
            </div>

            <!-- Информация о товаре -->
            <div class="tg-product-data">
                <!-- Линия данных о товаре (является ли дроп товаром) -->
                <div class="tg-product-data-line">
                    <div class="data-label">Дроп товар: </div>
                    <div :class="['data-value', tg_product._is_drop_ ? 'drop-product' : 'not-drop-product']"></div>
                </div>

                <!-- Линия данных о товаре (дроп цена) -->
                <div class="tg-product-data-line">
                    <div class="data-label">Дроп цена: </div>
                    <div class="data-value">{{ tg_product.drop_price }} ₽</div>
                </div>

                <!-- Линия данных о товаре (розничная цена) -->
                <div class="tg-product-data-line">
                    <div class="data-label">Розничная цена: </div>
                    <div class="data-value">{{ tg_product.retail_price }} ₽</div>
                </div>

            </div>

        </div>

        <!-- Правая сторона -->
        <div class="right-side">
            <!-- Убираем лишний блок .tg-product-lable-block и оставляем только .tg-product-labels -->
            <div class="tg-product-labels">
                <div class="tg-product-labels-block-header">Этикетки товара</div>

                <!-- Сами этикетки -->
                <div class="tg-product-label" :style="{backgroundColor: label.color}" v-for="label in tg_product.labels" :key="label.id">{{ label.label_name }}</div>
            </div>

            <!-- Блок кнопок ("Изменить", "Удалить") -->
            <div class="setting-buttons-container">
                <button class="setting-button delete" @click="deleteProduct()">Удалить</button>
                <button class="setting-button edit" @click="updateProduct()">Изменить</button>
                <button class="setting-button neutral">Таблица размеров</button>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'TgProductCardComponent',
    data() {
        return {
            isDropProduct: true,
            color: '#F2912E'
        };
    },
    props: {
        tg_product: {
            type: Object,
            required: true
        }
    },
    // Добавляем emits для событий
    emits: ['edit', 'delete'],
    methods: {
        deleteProduct() {
            // Используем эмит вместо прямой логики
            this.$emit('delete', this.tg_product);
        },
        updateProduct() {
            // Используем эмит для открытия модалки редактирования
            this.$emit('edit', this.tg_product);
        }
    }
}
</script>

<style scoped>
/* Стили остаются без изменений */
.tg-product-card-block {
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
    position: relative;
    height:76vw;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.08);
    border-radius: 20px;
    padding: 2vw;
    color: white;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2vw;
}

.left-side {
    height: 72vw;
    display: grid;
    grid-template-rows: 7fr 3fr;
    gap: 1vw;
    position: relative;
}

.tg-product-image-block {
    width: 100%;
    height: 100%;
    position: relative;
}

.tg-product-image {
    height: 44vw;
    width: 43.5vw;
    object-fit: cover;
    border-radius: 15px;
}

.tg-product-name {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(10px);
    text-align: center;
    padding: 1vw;
    font-size: 12px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
}

.tg-product-data-line {
    display: flex;
    gap: .5vw;
    margin-bottom: .5vw;
    font-size: 12px;
    align-items: center;
    background-color: rgba(255, 255, 255, .05);
    border-radius: 10px;
    padding: 0.25vw;
    justify-content: center;
}

.data-label {
    color:#005ADA;
}

.drop-product {
    background-color: green;
    width: 12px;
    height: 12px;
    border-radius: 50%;
}

.not-drop-product {
    background-color: red;
    width: 12px;
    height: 12px;
    border-radius: 50%;
}

.right-side {
    height: 76vw;
    display: grid;
    grid-template-rows: 1fr 1fr;
    gap: 1vw;
    position: relative;
}

/* Исправляем стиль, чтобы он был как в рабочем компоненте */
.tg-product-labels {
    position: relative;
    height: 100%;
    width: 100%;
    background-color: rgba(255, 255, 255, .05);
    border-radius: 15px;
    display: flex;
    overflow-y: auto;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    padding: 2vw;
}

.tg-product-labels-block-header {
    color: white;
    position: sticky;
    top: 0;
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 2vw;
    background-color:  #005ADA;
    border-radius: 10px;
    width: 100%;
    z-index: 10;
    text-align: center;
}

/* Стили для самих этикеток (добавьте, если нужно) */
.tg-product-label {
    width: 100%;
    padding: 1vw;
    background-color: rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    margin-bottom: 1vw;
    text-align: center;
}

.setting-buttons-container {
    display: grid;
    grid-template-rows: 1fr 1fr 1fr;
    height: 95%;
}

.setting-button {
    width: 100%;
    height: 10vw;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
    color: white;
    font-weight: bold;
}

.delete {
    background-color: #F71B47;
}

.edit {
    background-color: #F2912E;
}

.neutral {
    background-color: green;
}
</style>